module.exports = __webpack_public_path__ + "06_long_yellow.80f2da8c.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/mama/layer5/06_long_yellow.png
// module id = tCba
// module chunks = 0